<template>
  <v-col align="center">
    <v-card width="1000">
      <v-card-title>
        <ProductCardHeader :product-id="product.id" title="Agency Information" />
      </v-card-title>
      <v-card-text style="color: #4F4F4F">
        <v-row class="pa-3">
          Please confirm the following Agency information:
        </v-row>
        <v-row class="pl-5" style="text-align: start"><div><b>Name:</b> {{ agency.name }}</div></v-row>
        <v-row class="pl-5" style="text-align: start"><div><b>Phone:</b> {{ agency.phone }}</div></v-row>
        <v-row class="pl-5" style="text-align: start"><div><b>Street:</b> {{ agency.address.addressLine1 }}</div></v-row>
        <v-row class="pl-5" style="text-align: start"><div><b>City:</b> {{ agency.address.city }}</div></v-row>
        <v-row class="pl-5" style="text-align: start"><div><b>State:</b> {{ agency.address.state }}</div></v-row>
        <v-row class="pl-5" style="text-align: start"><div><b>Zip:</b> {{ agency.address.zipCode }}</div></v-row>
        <v-row class="pa-3">
          If this information is not correct, please close the Marketplace and update the information in HawkSoft CMS.
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row class="pa-3" justify="end" align="center">
          <v-btn color="#FF9E15" @click="confirmInformation()">Confirm Agency Information</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ProductCardHeader from '@/components/products/shared/ProductCardHeader';
import productIdMappingMixin from '@/mixins/productIdMappingMixin';

export default {
  name: 'AgencyConfirmation',
  components: {
    ProductCardHeader
  },
  mixins: [productIdMappingMixin],
  computed: {
    ...mapState(['agency']),
    ...mapGetters(['getProductByProductId']),
    product () {
      return this.getProductByProductId(this.getProductId('eSignature'));
    }
  },
  methods: {
    async confirmInformation () {
      this.$router.push('/product/eSignature/userSelection');
    }
  }
};

</script>
